export default __webpack_public_path__ + "static/media/332.66fef732.gif";